import { reactive, toRefs, onMounted, watch, nextTick, computed, ref } from 'vue'
import { useStore } from 'vuex'
import { myCarList } from '@/api/car'

export default function useCurrentCarInfo() {
  const store = useStore()
  const state = reactive({
    carInfo: store.state.currentCarInfo
  })
  const carInfoTxt = computed(() => {
    let plate = state.carInfo && state.carInfo.plate ? state.carInfo.plate : ''
    let model = state.carInfo && state.carInfo.model ? state.carInfo.model.replace(/\(.*?\)/g, '') : ''
    console.log('carInfoTxt---1111111', plate, model)
    return model ? `${plate || '暂无车牌'} | ${model}` : ''
  })
  const initCarInfo = async () => {
    let currentCarInfo = store.state.currentCarInfo
    let myDdefaultCar = store.state.myDdefaultCar
    if (currentCarInfo && currentCarInfo.vin) {
      state.carInfo = currentCarInfo
      console.log('initCarInfo--缓存获取currentCarInfo')
      return
    }
    if (myDdefaultCar && myDdefaultCar?.vin) {
      console.log('initCarInfo--setCurrentCarInfo-myDdefaultCar')
      store.dispatch('setCurrentCarInfo', myDdefaultCar)
      return
    }
    let { list = [] } = await myCarList()
    store.dispatch('setMyCarList', list)
    let defaultCar = list.find(({ defaultFlag }) => defaultFlag === 1)
    if (defaultCar && defaultCar?.vin) {
      console.log('initCarInfo--setCurrentCarInfo-myDdefaultCar-defaultFlag')
      store.dispatch('setCurrentCarInfo', myDdefaultCar)
      return
    }
    //没有默认车,取第一个
    if (list && list.length) {
      console.log('initCarInfo--setCurrentCarInfo-list[0]')
      store.dispatch('setCurrentCarInfo', list[0])
    }
  }
  watch([() => store.state.currentCarInfo, () => store.state.myDdefaultCar], ([currentCarInfo, myDdefaultCar]) => {
    console.log('watch--currentCarInfo/myDdefaultCar', currentCarInfo, myDdefaultCar)
    if (currentCarInfo && currentCarInfo.vin) {
      state.carInfo = currentCarInfo
      console.log('watch--currentCarInfo/')
      return
    }
    if (myDdefaultCar && myDdefaultCar.vin) {
      console.log('watch--/myDdefaultCar')
      state.carInfo = myDdefaultCar
      return
    }
    console.log('watch--/carInfo')
    state.carInfo = {}
  })
  onMounted(async () => {
    initCarInfo()
  })

  return {
    ...toRefs(state),
    carInfoTxt,
    initCarInfo
  }
}
